export default __webpack_public_path__ + "static/media/ac_hrw.33da3b78.bmp";